var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('personal-info-form',_vm._b({key:_vm.version,attrs:{"flat":""},on:{"saved":function (data) { return _vm.$emit('completed', data); },"update":function($event){_vm.version++}},scopedSlots:_vm._u([{key:"actions",fn:function(ref){
var loading = ref.loading;
var submitting = ref.submitting;
var submit = ref.submit;
return [_vm._t("actions",null,null,{ loading: loading, submitting: submitting, submit: submit })]}}],null,true)},'personal-info-form',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }